import { gql } from "@apollo/client";

export const UPDATE_OBSERVACION_PACIENTE_ASISTENCIAL = gql`
    mutation updateObservacionPacienteAsistencial(
        $idEvaluacion: Int!
        $mail: String
        $familiarTelefono: String
        $telefonoContacto: String
    ){
        updateObservacionPacienteAsistencial(
            idEvaluacion: $idEvaluacion
            mail: $mail
            familiarTelefono: $familiarTelefono
            telefonoContacto: $telefonoContacto
        ){
            idEvaluacion
        }
    }
`;